import {
  faEye,
  faHandFist,
  faPersonCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import Footer from "../../components/footer/Footer";
import Imagewheel from "../../components/imagewheel/Imagewheel";
import Newsletter from "../../components/newsletter/Newsletter";
import {
  AboutPageContainer,
  AboutSectionFourthContainer,
  AboutSectionPassionContainer,
  AboutSectionPassionImage,
  AboutSectionPassionIntroTitle,
  AboutSectionPassionLine,
  AboutSectionPassionText,
  AboutSectionPassionTextContainer,
  AboutSectionPassionTitle,
  AboutSectionQuote,
  AboutSectionQuoteContainer,
  AboutSectionQuoteGradientOverlay,
  AboutSectionQuoteImage,
  AboutSectionQuoteText,
  AboutSectionQuoteTextContainer,
  AboutSectionQuoteTextContainerQuote,
  AboutSectionQuoteTextContainerQuoteTitle,
  AboutSectionQuoteTextIntroTitle,
  AboutSectionThird,
  AboutSectionThirdCards,
  AboutSectionThirdCardsCard,
  AboutSectionThirdCardsCardIcon,
  AboutSectionThirdCardsCardReadMoreButton,
  AboutSectionThirdCardsCardText,
  AboutSectionThirdCardsCardTitle,
  AboutSectionThirdContainer,
  AboutSectionThirdIntroTitle,
  AboutSectionThirdTitle,
} from "./AboutStyles";
import { useEffect, useState } from "react";

function About() {
  const images = ["/assets/9.jpg", "/assets/10.jpg", "/assets/11.jpg"];
  const [expanded, setExpanded] = useState({
    missie: false,
    visie: false,
    betterWork: false,
  });

  const toggleExpand = (card) => {
    setExpanded((prev) => ({
      ...prev,
      [card]: !prev[card],
    }));
  };

  // Define the full text content
  const fullText = {
    missie: `Samen maken we de zorg beter. Met een diepgewortelde passie voor de zorg streven wij naar continuïteit, kwaliteit en betaalbaarheid. Wij brengen zorgprofessionals en zorgpartners bij elkaar om samen bij te dragen aan betere zorg, altijd met een persoonlijke benadering en een luisterend oor. Ons doel? Het werk leuker maken voor professionals en de zorg verbeteren voor cliënten.`,
    visie: `Door slimme oplossingen en transparante processen helpen wij zorginstellingen om beter, efficiënter en duurzamer te werken. Bij Smart-personeel geloven we in een zorg waar professionals ruimte krijgen om hun vak uit te oefenen zonder onnodige zorgen over administratie of personeelstekorten. Wij zijn er om te ondersteunen, te vernieuwen en te ontzorgen. Zo dragen we bij aan een zorg die zich kan richten op wat écht belangrijk is: de mensen die zorg nodig hebben.`,
    betterWork: `Door slimme oplossingen op het gebied van capaciteitplanning en management dragen wij bij aan een slimmer en beter werken met als doel een beter leven voor personeel en clienten. Speciaal voor uw organisatie ontwikkeld, meer dan alleen een oplossing, algemeen geaccepteerd door uw organisatie, realistisch opgezet en getoetst op uw werkvloer, tijdsbesparing in uw organisatie; op elk niveau.`,
  };

  /**
   * Start card animation only when card is visible
   */
  useEffect(() => {
    const cards = document.querySelectorAll(".home-about-card");

    const onScroll = () => {
      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          card.classList.add("is-visible");
        } else {
          card.classList.remove("is-visible");
        }
      });
    };

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <AboutPageContainer>
      {/* About: Imagewheel */}
      <Imagewheel images={images} isAbout={true} />

      {/* About: First Section */}
      <AboutSectionPassionContainer>
        <AboutSectionPassionImage src="/assets/18.jpg" alt="Smart Personeel" />
        <AboutSectionPassionTextContainer>
          <AboutSectionPassionIntroTitle>
            Over Ons: Met passie voor de zorg
          </AboutSectionPassionIntroTitle>
          <AboutSectionPassionTitle>
            Uit zorg ontstaan, met zorg gegroeid
          </AboutSectionPassionTitle>
          <AboutSectionPassionText>
            Wij zijn dé verbindende schakel tussen zorgorganisaties en
            zelfstandige zorgprofessionals. Ons uitzendbureau combineert
            expertise, snelheid en persoonlijk contact om de beste matches te
            maken in het zorglandschap. Van gehandicaptenzorg en jeugdzorg tot
            thuiszorg, GGZ en ziekenhuizen: wij begrijpen de vraag en leveren
            oplossingen die het verschil maken.
          </AboutSectionPassionText>
          <AboutSectionPassionLine />
        </AboutSectionPassionTextContainer>
      </AboutSectionPassionContainer>

      {/* About: Second Section */}
      <AboutSectionQuote>
        <AboutSectionQuoteImage src="/assets/5.jpg" alt="Smart Personeel" />
        <AboutSectionQuoteGradientOverlay />
        <AboutSectionQuoteContainer>
          <AboutSectionQuoteTextContainer
            style={{
              backgroundColor: "white",
              padding: "30px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.4)",
            }}
          >
            <AboutSectionQuoteTextIntroTitle>
              Smart Personeel
            </AboutSectionQuoteTextIntroTitle>
            <AboutSectionQuoteText>
              De zorg staat voor grote uitdagingen. Personeelstekorten, complexe
              zorgvragen en de behoefte aan flexibiliteit vragen om slimme
              oplossingen. Bij Smart-personeel begrijpen we die uitdagingen en
              bieden we een breed scala aan diensten om zorgorganisaties en
              zorgprofessionals te ondersteunen. Of u nu op zoek bent naar de
              juiste mensen voor uw organisatie, of zelf op zoek bent naar een
              nieuwe stap in uw carrière.
              <br />
              <br /> Wij staan voor u klaar. Wij denken met u mee om oplossingen
              te vinden die niet alleen aansluiten bij de huidige situatie, maar
              ook gericht zijn op de toekomst. Met persoonlijke aandacht en een
              professionele aanpak werken we samen aan zorg die werkt.
            </AboutSectionQuoteText>
          </AboutSectionQuoteTextContainer>
          <AboutSectionQuoteTextContainerQuote>
            <AboutSectionQuoteTextContainerQuoteTitle>
              “Samen werken aan slimme capaciteitsmanagement.”
            </AboutSectionQuoteTextContainerQuoteTitle>
          </AboutSectionQuoteTextContainerQuote>
        </AboutSectionQuoteContainer>
      </AboutSectionQuote>

      {/* About: Third Section */}
      <AboutSectionThird>
        <AboutSectionThirdContainer>
          <AboutSectionThirdIntroTitle>
            Smart Missie & Visie
          </AboutSectionThirdIntroTitle>
          <AboutSectionThirdTitle>
            Better Work, Better Life!
          </AboutSectionThirdTitle>
        </AboutSectionThirdContainer>

        <AboutSectionThirdCards>
          <AboutSectionThirdCardsCard className="home-about-card">
            <AboutSectionThirdCardsCardIcon icon={faHandFist} size={"3x"} />
            <AboutSectionThirdCardsCardTitle>
              Missie
            </AboutSectionThirdCardsCardTitle>
            <AboutSectionThirdCardsCardText>
              {expanded.missie
                ? fullText.missie
                : `${fullText.missie.substring(0, 150)}...`}
            </AboutSectionThirdCardsCardText>
            <AboutSectionThirdCardsCardReadMoreButton
              onClick={() => toggleExpand("missie")}
            >
              {expanded.missie ? "Lees Minder" : "Lees Meer"}
            </AboutSectionThirdCardsCardReadMoreButton>
          </AboutSectionThirdCardsCard>

          <AboutSectionThirdCardsCard className="home-about-card">
            <AboutSectionThirdCardsCardIcon icon={faEye} size={"3x"} />
            <AboutSectionThirdCardsCardTitle>
              Visie
            </AboutSectionThirdCardsCardTitle>
            <AboutSectionThirdCardsCardText>
              {expanded.visie
                ? fullText.visie
                : `${fullText.visie.substring(0, 150)}...`}
            </AboutSectionThirdCardsCardText>
            <AboutSectionThirdCardsCardReadMoreButton
              onClick={() => toggleExpand("visie")}
            >
              {expanded.visie ? "Lees Minder" : "Lees Meer"}
            </AboutSectionThirdCardsCardReadMoreButton>
          </AboutSectionThirdCardsCard>

          <AboutSectionThirdCardsCard className="home-about-card">
            <AboutSectionThirdCardsCardIcon
              icon={faPersonCircleCheck}
              size={"3x"}
            />
            <AboutSectionThirdCardsCardTitle>
              Better Work, Better Life!
            </AboutSectionThirdCardsCardTitle>
            <AboutSectionThirdCardsCardText>
              {expanded.betterWork
                ? fullText.betterWork
                : `${fullText.betterWork.substring(0, 150)}...`}
            </AboutSectionThirdCardsCardText>
            <AboutSectionThirdCardsCardReadMoreButton
              onClick={() => toggleExpand("betterWork")}
            >
              {expanded.betterWork ? "Lees Minder" : "Lees Meer"}
            </AboutSectionThirdCardsCardReadMoreButton>
          </AboutSectionThirdCardsCard>
        </AboutSectionThirdCards>
      </AboutSectionThird>

      {/* About: Fourth Section */}
      <AboutSectionFourthContainer>
        <AboutSectionPassionImage src="/assets/19.jpg" alt="Smart Personeel" />
        <AboutSectionPassionTextContainer>
          <AboutSectionPassionIntroTitle>
            Waarom kiezen voor Smart-personeel?
          </AboutSectionPassionIntroTitle>
          <AboutSectionPassionTitle>
            Omdat wij verder denken dan het invullen van een vacature.
          </AboutSectionPassionTitle>
          <AboutSectionPassionText>
            Wij leveren niet zomaar zorgprofessionals, wij leveren de mensen die
            jouw organisatie verder helpen. Of het nu gaat om tijdelijke
            ondersteuning, crisisinterventie of het uit handen nemen van
            administratieve lasten, wij zorgen ervoor dat jij de juiste match
            krijgt. Met transparantie, flexibiliteit en persoonlijke aandacht
            zorgen we ervoor dat jij kunt rekenen op een zorgoplossing die werkt
            – slim, efficiënt en duurzaam.
          </AboutSectionPassionText>
          <AboutSectionPassionLine />
        </AboutSectionPassionTextContainer>
      </AboutSectionFourthContainer>

      {/* About: Newsletter */}
      <Newsletter />

      {/* About: Footer */}
      <Footer />
    </AboutPageContainer>
  );
}

export default About;
